<template>
   <div class="change-approve-c">
      <div class="message-container">
         <p>
            <strong>{{ message.greeting }}</strong>
         </p>
         <p v-html="message.body"></p>

         <div class="changes-text" v-html="message.details"></div>
         <p>{{ message.closing }}</p>
      </div>

      <div class="change-approve-button-group-wrapper">
         <label for="Notes">Notes</label>
         <textarea name="" id="addNewNote" rows="3" v-model="serviceCenterNote" :placeholder="$t('requestFormComponent_textareaPlaceholder_label')"></textarea>

         <div class="buttons-wrapper">
            <template v-if="subType == 2">
               <UIButton className="default" :text="$t('flightChange_lblApprove')" @click.native="handleApprove(true)" />
            </template>
            <template v-else-if="subType == 3">
               <UIButton className="default" :text="$t('flightChange_lblApprove')" @click.native="handleApprove(true)" />
               <UIButton className="default" :text="$t('flightChange_lblPnrReverse')" @click.native="handleApprove(undefined, 1)" />
               <UIButton className="default" :text="$t('flightChange_lblPnrReissue')" @click.native="handleApprove(undefined, 2)" />
            </template>
         </div>
      </div>
   </div>
</template>

<script>
import Popup from "@/gts-popup.js";
import { taskService } from "@/service/index.js";
import UIButton from "@/components/unitary/Button.vue";
export default {
   name: "ChangeApprove",
   props: {
      message: {
         type: Object,
         required: true,
      },
      action: {
         type: Object,
         required: true,
      },
      subType: Number,
      taskId: Number,
   },
   components: {
      UIButton,
   },
   data() {
      return {
         serviceCenterNote: "",
      };
   },

   methods: {
      handlerRefresh() {
         this.$router.push(this.$route.path + "?taskopen=true").then(() => {
            window.location.reload();
         });
      },

      handleApprove(isConfirmed, type) {
         const self = this;
         let typeFMT;

         if (type == 1) {
            typeFMT = "PNR_Reverse";
         } else if (type == 2) {
            typeFMT = "PNR_Reissue";
         } else {
            typeFMT = "Approve";
         }

         this.$store.commit("app/setIsProgressGifActive", true);
         taskService
            .setflightchangeconfirmationtask({
               taskId: this.taskId,
               confirm: isConfirmed ?? false,
               newTaskType: type,
               note: this.serviceCenterNote,
            })
            .then((res) => {
               if (!res.result.success) {
                  Popup.warning(this.$i18n.t("Popup_lblWarning"), this.$i18n.t("Popup_txtFlightChangeError" + typeFMT), undefined, 10000);
                  this.$nextTick(() => {
                     if (document.body.querySelector("#popup-close-btn")) {
                        document.body.querySelector("#popup-close-btn").addEventListener("click", function () {
                           self.handlerRefresh();
                        });
                     }
                  });
               } else {
                  Popup.success(this.$i18n.t("Popup_lblSuccess"), this.$i18n.t("Popup_txtFlightChangeSuccess" + typeFMT), undefined, 10000);

                  this.$nextTick(() => {
                     if (document.body.querySelector("#popup-ok")) {
                        document.body.querySelector("#popup-ok").addEventListener("click", function () {
                           self.handlerRefresh();
                        });
                     }
                     if (document.body.querySelector("#popup-close-btn")) {
                        document.body.querySelector("#popup-close-btn").addEventListener("click", function () {
                           self.handlerRefresh();
                        });
                     }
                  });
               }
            })
            .catch((err) => {
               console.error(err);
            })
            .finally(() => {
               this.$store.commit("app/setIsProgressGifActive", false);
            });
      },
   },
};
</script>

<style lang="scss">
.changes-text {
   margin-top: 1rem;
   background: var(--gray-50);
   border-radius: 1rem;
   padding: 0.5rem;
   margin-bottom: 1rem;

   h2 {
      font-weight: 500;
      font-size: 1.125rem;
      padding-bottom: 0.5rem;
      
   }
   strong {
      font-weight: 500;
   }
   .haschanged {
      color: var(--green-600);
      font-weight: 500;
   }
   div {
      border-bottom: 3px solid var(--gray-200);
      padding: 1rem;

      &:last-child {
         border-bottom: none;
      }
   }
}
</style>

<style lang="scss" scoped>
$primary-color: var(--blue-500);
$hover-color: var(--blue-700);
$background-color: var(--gray-100);
$box-shadow: 0px 2px 4px var(--gray-1000-alpha-75);
$border-radius: 8px;
$button-padding: 10px 20px;
$button-font-size: 14px;

.change-approve-c {








   .message-container {
      background-color: $background-color;
      border-radius: $border-radius;
      margin-bottom: 2rem;
      padding: 1rem;
   }

   .change-approve-button-group-wrapper {
      display: flex;
      flex-direction: column;
      height: 100%;
      margin-bottom: 1rem;
      gap: 0.5rem;

      textarea {
         padding: 0.5rem;
         border: 2px solid var(--gts-input-border);
         border-radius: 5px;
         resize: none;
         margin-bottom: 0.5rem;
      }

      .buttons-wrapper {
         width: 100%;
         display: flex;
         justify-content: flex-end;
         gap: 0.5rem;
         gap: 0.5rem;
      }
   }

   .change-list {
      li {
         margin: 0.5rem 0;
         padding: 0.5rem 0;
         border-bottom: 1px solid var(--gray-300);
      }
   }

   .approve-button {
      background-color: $primary-color;
      color: white;
      border: none;
      padding: $button-padding;
      border-radius: 5px;
      cursor: pointer;
      font-size: $button-font-size;

      &:hover {
         background-color: $hover-color;
      }
   }
}
</style>
